<template>
  <div class="checkout-step-container">
    <div class="payment__methods">
      <h2>{{ $t('Payment methods') }}</h2>
      <div class="_loading" v-show="loadingPaymentData"></div>
      <div class="block__holder" v-show="!loadingPaymentData">
        <ValidationProvider class="payment__methods-list" v-slot="{ errors, classes }" rules="required" tag="ul" :name="$t('Payment method')">
          <input type="hidden" v-model="selectedPaymentMethod"/>
          <checkout-payment-methods-default v-for="method in paymentMethods" :key="method['code']" :payment-method="method" :selected-payment-method="selectedPaymentMethod"></checkout-payment-methods-default>
          <span class="field-error" v-if="errors.length">{{ $t(errors[0]) }}</span>
        </ValidationProvider>
      </div>
    </div>
    <div class="order-comment">
      <h2>{{ $t('Order comments') }}</h2>
      <div class="field__group">
        <label for="order-comment">{{ $t('Comments on your order') }} <small>({{ $t('optional') }})</small></label>
        <textarea
          id="order-comment"
          name="order_comment"
          rows="3"
          maxlength="2000"
          :placeholder="$t('Any comments about your order?')"
          v-model="orderComment"
        ></textarea>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import {Component, Vue, Watch} from 'vue-property-decorator';
  import ServiceContainer from '@flashpointbv/solar-service-container';
  import {ValidationProvider, extend} from 'vee-validate';
  import {required} from 'vee-validate/dist/rules';

  extend('required', required);

  @Component({
    name: 'checkout-payment-detail',
    components: {
      'checkout-payment-methods-default': ServiceContainer().getComponent('checkout-payment-methods-default'),
      ValidationProvider
    }
  })

  export default class extends Vue {
    private get paymentMethods(): Array<object> {
      return this.$store.getters['CheckoutPayment/paymentMethods'];
    }

    private get selectedPaymentMethod(): object | string {
      return Object.keys((this.$store.getters['CheckoutPayment/selectedPaymentMethod'] || {})).length > 0 ? this.$store.getters['CheckoutPayment/selectedPaymentMethod'] : '';
    }

    private get loadingPaymentData(): boolean {
      return this.$store.getters['CheckoutPayment/loadingPaymentData'];
    }

    private get orderComment(): string {
      return this.$store.state.CheckoutGlobal?.orderComment || '';
    }

    private set orderComment(value: string) {
      this.$store.dispatch('CheckoutGlobal/setOrderComment', value);
    }

    private get shippingMethod(): object | null {
      return this.$store.getters['CheckoutShipping/shippingMethod'];
    }

    private get currentStep(): number {
      return this.$store.getters['CheckoutGlobal/currentStep'];
    }

    @Watch('selectedPaymentMethod', { deep: true })
    async handleSelectedPaymentMethod(nv, ov) {
      if (nv && nv !== ov && nv.hasOwnProperty('code')) {
        await this.$store.dispatch('CheckoutPayment/setPaymentMethod', nv);
      }
    }

    @Watch('currentStep')
    async handleStepChange(newStep: number) {
      if (newStep === 3) {
        await this.collectPaymentMethods();
      }
    }

    @Watch('shippingMethod', { deep: true })
    async handleShippingMethodChange(newMethod: object, oldMethod: object) {
      if (this.currentStep === 3 && newMethod && (!oldMethod || newMethod['method_code'] !== oldMethod['method_code'])) {
        await this.collectPaymentMethods();
      }
    }

    private async collectPaymentMethods(): Promise<any> {
      if (!this.shippingMethod || Object.keys(this.shippingMethod).length === 0) {
        return;
      }

      await this.$store.dispatch('CheckoutPayment/collectPaymentMethods');
    }

    private async created(): Promise<void> {
      if (this.currentStep === 3) {
        await this.collectPaymentMethods();
      }
    }
  }
</script>
